import keyMirror from 'keymirror';

export default keyMirror({
  PRODUCT_LISTING: null,
  PRODUCT_DETAIL: null,
  CART: null,
  SEARCH_RESULTS: null
});
